import {Constructor} from "../../global/constructor";
import SnapshotInterface from "../interfaces/snapshotInterface";
import {ArrayHelper} from "../helpers/arrayHelper";
import {SnapshotType} from "../enums/snapshotType";
import IModel from "../interfaces/modelInterfaces";

export default function Documentable<T extends Constructor<IModel>>(BaseClass: T){

  return class extends BaseClass implements IModel{
    _snapshots: SnapshotInterface[] = [];
    is_published: boolean;
    attempted_to_publish?: boolean;
    u_at;
    c_at;
    id;

    // ******************** DOCUMENT ******************** //

    canUnpublish(): boolean {
      return this.is_published;
    }

    get snapshots() {
      return this._snapshots;
    }

    set snapshots(value) {
      this._snapshots = value;
    }

    get backedUpSnapshots(): SnapshotInterface[] {
      return ArrayHelper.sortByDate(this.snapshots.filter(record => record.type === SnapshotType.Backup), 'c_at');
    }

    get previouslyPublishedSnapshots(): SnapshotInterface[] {
      if (this.publishedSnapshots.length === 0) return [];
      let records = ArrayHelper.sortByDate(this.publishedSnapshots, 'c_at');
      if (this.is_published) records = records.slice(1);
      return records;
    }

    get publishedSnapshots(): SnapshotInterface[] {
      return ArrayHelper.sortByDate(this.snapshots.filter(record => record.type === SnapshotType.Publish), 'c_at');
    }

    get lastBackup(): SnapshotInterface {
      const backups = this.backedUpSnapshots;
      if (backups.length > 0) {
        return backups[0];
      }
    }

    get canBackUp(): boolean {
      const bufferTime = 500; // milliseconds
      const lastBackup = this.lastBackup;
      const updateTime = (new Date(this.u_at)).getTime();
      const createdTime = (new Date(this.c_at)).getTime();
      if (lastBackup) {
        return updateTime - (new Date(lastBackup.c_at)).getTime() > bufferTime;
      } else {
        return updateTime - createdTime > bufferTime;
      }
    }

    get isPersisted(): boolean {
      return !!this.id
    }

    // ******************** DOCUMENT END ******************** //
  }

}